import { Component, EventEmitter, input, Input, Output } from "@angular/core";

@Component({
  selector: "page-card-action",
  template: "",
  standalone: false
})
export class PageCardActionComponent {
  @Input() title: string = "";
  @Input() icon: string = "";
  @Input() disabled: boolean = false;
  @Output() onClick: EventEmitter<void> = new EventEmitter();

  onCLickFunction($event: MouseEvent) {
    if (this.disabled) {
      return;
    }

    this.onClick.emit();
    $event.stopImmediatePropagation();
  }
}
